const STYLES = {
  success: {
    wrap: "text-emerald-700 bg-gradient-to-br from-emerald-50 to-emerald-100/40 border-emerald-200",
    label: "text-emerald-600/70",
  },
  danger: {
    wrap: "text-red-700 bg-gradient-to-br from-red-50 to-red-100/40 border-red-200",
    label: "text-red-600/70",
  },
  warning: {
    wrap: "text-amber-700 bg-gradient-to-br from-amber-50 to-amber-100/40 border-amber-200",
    label: "text-amber-600/70",
  },
  neutral: {
    wrap: "text-slate-700 bg-white border-slate-200",
    label: "text-slate-500",
  },
};

export default function StatCard({ label, value, tone = "neutral" }) {
  const style = STYLES[tone] || STYLES.neutral;

  return (
    <div className={`rounded-2xl border p-4 ${style.wrap}`}>
      <p className={`text-[10px] font-bold uppercase tracking-widest ${style.label}`}>
        {label}
      </p>
      <p className="mt-2 text-3xl font-black leading-none">{value}</p>
    </div>
  );
}
